/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-02-18 15:48:45
 * @LastEditTime: 2025-04-16 09:08:42
 */
import { createSlice } from '@reduxjs/toolkit'

export interface IUserStateType {
  userInfo: IUserInfoType | any,
  loginStatus: boolean,
  completed: boolean,
  cartCount: number, 
  applyCount: number
}
export interface IUserInfoType {
  name: string
  tel: string
  [key: string]: any
}
export const initialState:IUserStateType = {
  userInfo: {},
  loginStatus: false,
  completed: false,
  cartCount: 0, // 购物车数量
  applyCount: 0 // 售后数量
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = Object.assign({}, action.payload)
    },
    setLoginStatus: (state, action) => {
      state.loginStatus = action.payload
    },
    setCompleted: (state, action) => {
      state.completed = action.payload
    },
    setCartCount: (state, action) => {
      state.cartCount = action.payload
    },
    setApplyCount: (state, action) => {
      state.applyCount = action.payload
    },
  }
})
export const { setUserInfo, setLoginStatus, setCompleted, setCartCount, setApplyCount } = userSlice.actions
export default userSlice.reducer